// For customer companies on a free trial: a calm line in the last week, and a clear message when it has ended.
// The trial itself is enforced on VERA's server; this only says it plainly.
import { useEffect, useState } from "react";
import { useStudio } from "./ui";
import { cpFetch } from "../lib/controlPlane";
import { vera } from "../api/vera";
import { L } from "../lib/i18n";

type Trial = { trial: boolean; daysLeft?: number; ends?: string; over?: boolean };

export function TrialNotice() {
  const { profile, getToken } = useStudio();
  const [t, setT] = useState<Trial | null>(null);
  useEffect(() => {
    if (!profile.external || vera.mode !== "live") return;
    cpFetch<Trial>(getToken, "/v1/me/trial").then(setT).catch(() => setT(null));
  }, [profile.external, getToken]);
  if (!t?.trial || (!t.over && (t.daysLeft ?? 99) > 7)) return null;
  return (
    <div className={`notice ${t.over ? "" : "calm"}`} style={{ margin: "0 0 12px" }}>
      <span style={{ fontSize: 13 }}>{t.over
        ? L("Your free trial of VERA Studio has ended. Your work is kept safely; contact VERANeural to continue.", "Prova falas e VERA Studio ka mbaruar. Puna juaj ruhet e sigurt; kontaktoni VERANeural për të vazhduar.")
        : L(`Your free trial ends in ${t.daysLeft} day${t.daysLeft === 1 ? "" : "s"} (${t.ends}).`, `Prova falas mbaron pas ${t.daysLeft} ${t.daysLeft === 1 ? "dite" : "ditësh"} (${t.ends}).`)}</span>
    </div>
  );
}
